import config from "player/config";
import scriptLoader from 'utils/script-loader';

const loadSvpLibrary = async () => {
    return import( /* webpackMode: "eager"*/ './index').then(SVP => [
        SVP.default,
        SVP.initialize
    ]);
};

const loadJwPlayer = async (root) => {
    const PLAYER_LIB = config.cdn.player + '/jwplayer.js';

    if (root.define && root.define.amd) {
        return new Promise((resolve) => {
            root.require([PLAYER_LIB], function (jwplayer) {
                root.jwplayer = jwplayer;
                resolve(jwplayer);
            });
        })
    } else {
        return scriptLoader(PLAYER_LIB);
    }
};


(async function(root) {
    const onReady = root.onSvpPlayerReady;

    // onSvpPlayerReady is required callback to handle due to SDK async loading
    if(onReady) {
        loadJwPlayer(root)
            .then(loadSvpLibrary)
            .then(library => {
                const [SVP, initialize] = library;
                root.SVP = SVP;
                onReady();
                initialize();
            });
    }
}(window));
